// extracted by mini-css-extract-plugin
module.exports = {"roadMapTable":"Roadmap_roadMapTable__11-IM","old":"Roadmap_old__1-a1r","current":"Roadmap_current__3Wj4T","new":"Roadmap_new__vwVsr"};